import { ChevronDownIcon } from "@heroicons/react/20/solid";

import { classNames } from "../../utils";
import Button from "./Button";
import ButtonGroup from "./ButtonGroup";
import Dropdown, { DropdownLink } from "./Dropdown";

type Props = {
  children: React.ReactNode;
  className?: string;
  links: DropdownLink[];
  loading?: boolean;
  onClick?: () => void;
  size?: "lg" | "md" | "sm" | "xs";
};

export default function DropdownButton({ children, className, links, loading, onClick, size }: Props) {
  if (onClick) {
    return (
      <ButtonGroup>
        <Button className={className} loading={loading} onClick={onClick} size={size} variant="action">
          {children}
        </Button>
        <Dropdown
          buttonAs={Button}
          buttonProps={{ className: classNames(className, "px-1.5"), loading, size, variant: "action" }}
          links={links}
        >
          <ChevronDownIcon />
        </Dropdown>
      </ButtonGroup>
    );
  }
  return (
    <Dropdown links={links}>
      <Button className={className} loading={loading} size={size} variant="action">
        {children}
        <ChevronDownIcon />
      </Button>
    </Dropdown>
  );
}
